import { TYPE_COLLECTION_FILTER } from '../constants/applied-filter-type';
import { getFilterTypeForEditorType } from './filter-type-for-editor-type';

export const setFilterValueBasedOnEditorType = (editorType, filter, updatedValue) => {
  const filterType = getFilterTypeForEditorType(editorType);
  const onlyTypeThatUsesTheValuesProp = TYPE_COLLECTION_FILTER;
  if (filterType === onlyTypeThatUsesTheValuesProp) {
    return {
      ...filter,
      values: updatedValue,
    };
  }
  return {
    ...filter,
    value: updatedValue,
  };
};
